import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { AdminService } from '@banyan/modules/admin/services/admin.service';
import { TranslateModule } from '@ngx-translate/core';

import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'app-feedback-panel',
  templateUrl: './feedback-panel.component.html',
  styleUrls: ['./feedback-panel.component.scss'],
  standalone: true,
  imports: [CommonModule, MatExpansionModule, MatIconModule, ButtonComponent, TranslateModule],
})
export class FeedbackPanelComponent {
  @Input() waitingReview: boolean | undefined = true;
  @Input() rating: number = 0;
  @Input() comment: string | undefined = '';
  @Input() createdAt: string | undefined = '';
  @Input() set shouldPanelOpen(openState: boolean) {
    this.panelOpenState = openState;
  }
  @Output() reviewed = new EventEmitter<void>();
  
  protected panelOpenState: boolean = false;
  adminService = inject(AdminService);

  markAsReviewed() {
    this.reviewed.emit();
  }

  isStarActive(index: number): boolean {
      return this.rating !== null
      ? index <= this.rating
      : index <= this.rating;
  }
}
